import { compact, uniqBy } from 'lodash';
import type { CustomizablePdfDeal } from '@makemydeal/dr-platform-types';

export const joinNonEmpty = (parts: (string | undefined)[], separator = ' '): string => compact(parts).join(separator);

export const uniqueByVin = (deals: CustomizablePdfDeal[]): CustomizablePdfDeal[] => uniqBy(deals, ({ vehicle }) => vehicle.vin);

export const hasCommonVehicle = (deals: CustomizablePdfDeal[]): boolean => uniqueByVin(deals).length === 1;
